export default {
  envName: 'development',
  baseURL: 'https://elbdev.frontm.ai',
  gRPCURL: 'https://gwdev.frontm.ai',
  botFilesAPI: 'https://gwdev.frontm.ai/devproxy/dev/botfile?path=',
  filesAPI: 'https://3nf11ibj25.execute-api.us-east-1.amazonaws.com/dev',

  jwtLoginURL: "https://6sxl0oh685.execute-api.us-east-1.amazonaws.com/dev",
  xApiKeyForJwtLogin : 'hBnok9rUPB1hyZwpHI5Gb6s3Tp1Y7Qll2Nzpr9xe',
  imgUploadAPI: 'https://gwdev.frontm.ai/devproxy/dev',
  contentURL: 'https://gwdev.frontm.ai/devproxy/botLogos/',
  soundURL: 'https://gwdev.frontm.ai/devproxy/sounds/',
  paymentGatewayKey: "pk_test_tXlIyqK3p7LCtcF9JGwDgW0C",
  webertcSignalServer: 'gwdev.frontm.ai',
  mapURL: 'https://devproxymaps.frontm.ai/styles/klokantech-basic/style.json',
  sipURI: 'frontmsecureweb@pstn-dev.frontm.ai',
  sipPassword: 'frontm@123^%',
  sipWebsocket: 'wss://pstn-dev.frontm.ai:8089/ws',
  dailyPlatformUrl: 'https://frontm.daily.co/',
  daily_baseUrl: 'https://y7uq3an27c.execute-api.us-east-1.amazonaws.com/item/video',
  xApiKey: 'PUQmy8zhBD6ER7WDevZZJ1KU2BPhntOM90jhLJEO',
  userImageBaseUrl: "https://gwdev.frontm.ai/devproxy/dev/file/profile-pics",
  TokenSecretKey: "4DjEEHV4feUWpvJARMSAEJ4E7JDOwUtQ7F6YYd21SQMJyM1TPoCjLeFAUe3vpQceWmGRrJRdh1z",
  defaultHomePagebaseUrl: "spinnetdev.frontm.ai",
  googleClientId: '306005128887-19ga1bg0sl09tj652icn1220v27p15co.apps.googleusercontent.com',

  //Apptypes
  vikandWebAppType: "vikand",
  stationoneAppType: "stationsatcom",
  onshipAppType: "onship",
  seamedexAppType: "seamedix",
  seadanceAppType: "seadance",

  //authCode
  onshipDomain: 'onshipEndUser',
};
